// Module
var code = "<template> <div class=\"slide-animate\" if.bind=\"stage == 'error'\"> <h3 class=\"text-center\"> Oops, something went wrong! </h3> <div class=\"text-muted text-center\"> This login attempt failed. Try again or <a class=\"link-light\" href=\"https://www.axxess.com/support\">contact support</a>. </div> </div> </template>";
// Exports
export default code;